import { render } from "./Alerts.vue?vue&type=template&id=a8343e88&scoped=true"
import script from "./Alerts.vue?vue&type=script&setup=true&lang=js"
export * from "./Alerts.vue?vue&type=script&setup=true&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=a8343e88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8343e88"],['__file',"src/components/tools/components/Alerts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8343e88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8343e88', __exports__)) {
    api.reload('a8343e88', __exports__)
  }
  
  module.hot.accept("./Alerts.vue?vue&type=template&id=a8343e88&scoped=true", () => {
    api.rerender('a8343e88', render)
  })

}


export default __exports__